/**
    * @fileoverview Generated Platform Configuration
    * @description Auto-generated during token build process
    * @generated 2025-12-15T21:59:19.339Z
    */

    export const CURRENT_PLATFORM = "mobile" as const;

    export type Platform = "tv" | "web" | "mobile";
  